import api from '../../util/api'

const state = {
  isLoggedIn: false,
}
const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn
  },
}
const actions = {
  loginUser({ commit, dispatch }, args) {
    api
      .loginUser(args.email, args.password)
      .then(() => {
        commit('isLoggedIn', true)
        args.callback()
      })
      .catch((e) => {
        dispatch('handleError', e)
      })
  },
  logoutUser({ commit }, args) {
    commit('isLoggedIn', false)
    args.callback()
  },
  forceLogoutUser({ commit }) {
    commit('isLoggedIn', false)
  },
}

const mutations = {
  isLoggedIn(state, val) {
    state.isLoggedIn = val
    localStorage.setItem('isLoggedIn', val)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
